import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAdminOrAbove } from './roles';

function AdminRoute() {
  const userRole = useSelector((state) => state.auth.userDetails?.role);

  return isAdminOrAbove(userRole) ? <Outlet /> : <Navigate to="/" replace />;
}

export default AdminRoute;
